import { BillInvoice, EnergyDataPoint, TariffPlan, UserAccount, InAppNotification, ContractedPlace } from '../types/energy';

// SymEnergy Official Tariff: 【夜生活フィットプラン】 (Night Lifestyle Fit Plan)
export const DEFAULT_TARIFF: TariffPlan = {
  id: 'sym-night-plan-standard',
  name: 'シン・エナジー【夜生活フィットプラン】',
  provider: 'シン・エナジー株式会社 (SymEnergy Inc.)',
  unitRateDay: 26.25, // デイタイム (平日 9:00 - 16:00 / 土日祝 8:00 - 22:00) ¥26.25/kWh
  unitRateLife: 32.65, // ライフタイム (平日 生活時間 6:00 - 9:00, 16:00 - 23:00) ¥32.65/kWh
  unitRateNight: 18.88, // ナイトタイム (平日 23:00 - 06:00 割安 / 土日祝 22:00 - 08:00) ¥18.88/kWh
  has3TierPricing: true,
  tierTiers: {
    day: {
      name: 'デイタイム (昼時間)',
      weekdayHours: '09:00 〜 16:00',
      weekendHours: '08:00 〜 22:00',
      rate: 26.25,
      description: '平日の日中標準時間帯',
      colorClass: 'text-sky-400'
    },
    life: {
      name: 'ライフタイム (生活時間)',
      weekdayHours: '06:00 〜 09:00 / 16:00 〜 23:00',
      weekendHours: '対象外 (土日祝は設定なし)',
      rate: 32.65,
      description: '朝の身支度・夕方から夜の団らん活動ピーク時間帯',
      colorClass: 'text-amber-400'
    },
    night: {
      name: 'ナイトタイム (夜時間)',
      weekdayHours: '23:00 〜 翌06:00',
      weekendHours: '22:00 〜 翌08:00',
      rate: 18.88,
      description: '夜間格安単価！夜間充電やエコキュート・家電タイマー活用に最適',
      colorClass: 'text-teal-400'
    }
  },
  standingCharge: 36.00,
  renewableSurcharge: 3.49,
  currency: '¥',
  contractEndDate: '',
  mprnNumber: '',
  meterSerial: '',
  area: ''
};

// Default Clean Account State (Mock data completely disabled)
export const INITIAL_ACCOUNT: UserAccount = {
  accountNumber: '',
  accountHolder: '',
  serviceAddress: '',
  meterType: 'スマートメーター (時間帯別契約)',
  contractCapacity: '',
  paymentMethod: 'credit_card',
  paymentDetails: '',
  currentBalance: 0,
  nextBillingDate: '',
  estimatedNextBill: 0,
  currentPlaceId: '',
  contractedPlaces: [],
  tariff: DEFAULT_TARIFF
};

// Zero mock places, invoices, or telemetry
export const DEMO_CONTRACTED_PLACES: ContractedPlace[] = [];
export const REAL_CONTRACTED_PLACES: ContractedPlace[] = [];
export const INITIAL_INVOICES: BillInvoice[] = [];
export const DEMO_INVOICES: BillInvoice[] = [];

export function generateHourlyUsage(_isWeekend = false): EnergyDataPoint[] {
  return [];
}

export function generateDailyUsage(): EnergyDataPoint[] {
  return [];
}

export function generateMonthlyUsage(): EnergyDataPoint[] {
  return [];
}

export function generatePlace2DailyUsage(): EnergyDataPoint[] {
  return [];
}

export function generateSingleDayHourlyUsage(
  _dateIso: string,
  _totalKwh: number,
  _dayKwh: number,
  _lifeKwh: number,
  _nightKwh: number,
  _isWeekend: boolean
): EnergyDataPoint[] {
  return [];
}

export function generate7DaysHourlyUsage(_placeId: string): EnergyDataPoint[] {
  return [];
}

export function generatePlace2HourlyUsage(_dateIso = ''): EnergyDataPoint[] {
  return [];
}

export function getPlaceData(_placeId: string): {
  monthlyUsage: EnergyDataPoint[];
  dailyUsage: EnergyDataPoint[];
  hourlyUsage: EnergyDataPoint[];
  invoices: BillInvoice[];
} {
  return {
    monthlyUsage: [],
    dailyUsage: [],
    hourlyUsage: [],
    invoices: []
  };
}

export const INITIAL_NOTIFICATIONS: InAppNotification[] = [];

export const SAMPLE_PORTAL_HTML = '';
export const SAMPLE_DAILY_JS_SNIPPET = '';
export const SAMPLE_HOURLY_JS_SNIPPET = '';
